import { Capacitor, registerPlugin } from '@capacitor/core';
import { apiRequest } from './apiClient';

const InstallAttribution = registerPlugin('InstallAttribution');
const CLICK_TOKEN_PATTERN = /^[A-Za-z0-9_-]{24,128}$/;

export async function getPendingInstallAttribution() {
  if (Capacitor.getPlatform() !== 'android' || !Capacitor.isNativePlatform()) return null;
  try {
    const result = await InstallAttribution.get();
    if (!result?.available || !result.referrer) return null;
    const params = new URLSearchParams(String(result.referrer));
    const clickToken = String(params.get('click_id') || '').trim();
    if (!CLICK_TOKEN_PATTERN.test(clickToken)) return null;
    return {
      provider: 'google_play',
      clickToken,
      clickTimestampSeconds: Number(result.clickTimestampSeconds || 0),
      installTimestampSeconds: Number(result.installTimestampSeconds || 0),
      installVersion: String(result.installVersion || '').slice(0, 32),
      installReported: result.installReported === true,
    };
  } catch {
    // Referrer ölçümü kayıt akışını hiçbir koşulda engellemez.
    return null;
  }
}

export async function reportPendingInstallAttribution() {
  const acquisition = await getPendingInstallAttribution();
  if (!acquisition || acquisition.installReported) return acquisition;
  try {
    const response = await apiRequest('/website-traffic/install', {
      method: 'POST',
      body: JSON.stringify({ acquisition }),
    });
    if (response?.matched === true) {
      await InstallAttribution.markInstallReported();
      return { ...acquisition, installReported: true };
    }
  } catch {
    // Ağ yoksa sonraki uygulama açılışında tek sefer daha denenir.
  }
  return acquisition;
}

export async function markInstallAttributionConsumed() {
  if (Capacitor.getPlatform() !== 'android' || !Capacitor.isNativePlatform()) return;
  try {
    await InstallAttribution.markConsumed();
  } catch {
    // Backend tarafı idempotenttir; temizleme sonraki başarılı kayıtta yenilenir.
  }
}
